/**
 * Do not edit directly
 * Generated on Fri, 11 Sep 2026 19:26:46 GMT
 */

export const xs = "4px";
export const sm = "8px";
export const md = "16px";
export const lg = "32px";
export const xl = "64px";
